/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement
} from '@chakra-ui/core';

/**
 * Dependênicas internas
 */
import getInformacoesDoCampo from 'utils/form/getInformacoesDoCampo';
import CarregandoInput from 'apresentacao/form/CarregandoInput';

const Logradouro = props => {
  const { formik, isLoading, cobranca, isDisabled, ...rest } = props;

  const nomeDoCampo = cobranca ? 'logradouroCobranca' : 'logradouro';
  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={possuiErroDeValidacao}
      {...rest}
    >
      <FormLabel htmlFor={nomeDoCampo}>Logradouro</FormLabel>
      <InputGroup>
        <Input
          type="text"
          id={nomeDoCampo}
          name={nomeDoCampo}
          onChange={handleChange}
          onBlur={handleBlur}
          value={valor}
          autoComplete="off"
          isDisabled={isLoading || isDisabled}
        />
        <InputRightElement>
          {isLoading && <CarregandoInput />}
        </InputRightElement>
      </InputGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Logradouro);
